import { render } from "./AdministratorListPostContent.vue?vue&type=template&id=66369a44&scoped=true"
import script from "./AdministratorListPostContent.vue?vue&type=script&lang=js"
export * from "./AdministratorListPostContent.vue?vue&type=script&lang=js"

import "./AdministratorListPostContent.vue?vue&type=style&index=0&id=66369a44&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66369a44"]])

export default __exports__